import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Faq from './pages/Faq';
import Pricing from './pages/Pricing';
import Rooms from './pages/Rooms';
import RoomsSuite from './pages/RoomsSuite';
import RoomsSearch from './pages/RoomsSearch';
import RoomDetails from './pages/RoomDetails';
import Services from './pages/Services';
import ShopCart from './pages/ShopCart';
import ShopCheckout from './pages/ShopCheckout';
import ShopProducts from './pages/ShopProducts';

function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/rooms" element={<Rooms />} />
          <Route path="/rooms-suite" element={<RoomsSuite />} />
          <Route path="/rooms-search" element={<RoomsSearch />} />
          <Route path="/room-details" element={<RoomDetails />} />
          <Route path="/services" element={<Services />} />
          <Route path="/cart" element={<ShopCart />} />
          <Route path="/checkout" element={<ShopCheckout />} />
          <Route path="/shop" element={<ShopProducts />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
